import React from "react";
import classNames from "classnames";

interface ToolbarProps {
    className?: string;
    size?: "" | "sm" | "md" | "lg";
    gap?: number;
    children: any;
    [x: string]: any;
}

export const Toolbar = ({ className, size, gap, children, ...props }: ToolbarProps) => {
    var cn = classNames(className, "toolbar", {
        "toolbar-sm": size === "sm",
        "toolbar-md": size === "md",
        "toolbar-lg": size === "lg",
        "gap-1": gap === 1,
        "gap-2": gap === 2,
        "gap-3": gap === 3,
        "gap-4": gap === 4,
        "gap-5": gap === 5,
    });
    return (
        <div className={cn} {...props}>
            {children}
        </div>
    );
};

export default Toolbar;
